<template>
  <!-- treeselect/cascader 本地树/级联类：multiple + show_search + 树形数据 JSON -->
  <a-row :gutter="16">
    <SelectionModeConfig
      :config="config"
      field="multiple"
    />
    <ShowSearchConfig :config="config" />
    <TreeDataConfig :config="config" />
  </a-row>
</template>

<script setup lang="ts">
import SelectionModeConfig from '../SelectionModeConfig.vue';
import ShowSearchConfig from '../ShowSearchConfig.vue';
import TreeDataConfig from '../TreeDataConfig.vue';

defineProps<{ config: any }>();
</script>
